import React, { useState } from 'react';
import { Form, Modal, Row, Select, message, Col } from 'antd';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { usePersistedStore } from '../../store/persisted-store';
import config from '../../config';
import axios from '../../axios';
import ValidatorHelpers from '../helpers/ValidatorHelper'


export default function AddUser() {
    const general = useGeneralStore();
    const visible = general.view.userUploadExcel;
    const { business, auth } = usePersistedStore()
    const roleList = business.businesses.roles.Roles;
    const userToken = auth.userToken;

    const [form] = Form.useForm();
    const [excelFile, setExcelFile] = useState('');

    const [loading, setLoading] = useState(false);


    const excelUploader = async (e) => {

        const acceptedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

        if (e) {

            const file = e.target.files[0];

            if (!acceptedTypes.includes(file.type)) {
                setExcelFile("")
                form.setFieldsValue({ excelFile: null });
                message.error('لطفاً یک فایل اکسل انتخاب نمایید.');
                return false;
            }
        }
        setExcelFile(e.target?.files[0])
    }

    function onFinish(values) {

        const dataToSend = new FormData();
        const roleIds = values.RoleIds;

        dataToSend.append("excelFile", excelFile)
        roleIds.map((role) => (dataToSend.append("RoleIds", role)))

        try {
            setLoading(true)
            axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: `v1/user/group-registration`,
                headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "multipart/form-data" },
                data: dataToSend,
            }).then((response) => {

                if (response?.status === 200) {
                    message.success(`با موفقیت بارگذاری شد`);
                    setExcelFile("")
                    form.setFieldsValue({ excelFile: null });
                    form.resetFields();
                    general.ToggleUserUploadExcel()

                }
                setLoading(false)
            })
        } catch (error) {
            message.error(`خطا در بارگذاری فایل`);
            setLoading(false)
        }

    }

    return (
        <Modal
            width={800}
            className="custom-table"
            title="بارگزاری لیست"
            open={visible}
            footer={false}
            onCancel={() => general.ToggleUserUploadExcel()}>
            <div className='mt-5 users-buttons'>
                <Form
                    className="file-upload" form={form} layout="vertical" onFinish={onFinish}>

                    <Row >
                        <Col span={12}>
                            <Form.Item name="RoleIds" label="نقش‌های کاربر:" rules={ValidatorHelpers.required("نقش ها")}>
                                <Select mode="multiple" placeholder="نقش‌ها را انتخاب کنید">
                                    {roleList?.map(role => (
                                        <Select.Option key={role.Id} value={role.Id}>
                                            {role.Title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24} >

                            <Form.Item name="excelFile" label="آپلود فایل:" onSubmit={(e) => e.preventDefault()} className='mt-3' rules={ValidatorHelpers.required("فایل")}>
                                <input type="file" accept=".xlsx, .xls" id="excelFile"
                                    onChange={(e) => excelUploader(e)}
                                />
                            </Form.Item>

                        </Col>
                        <Col span={24} >

                            <button type="button" className="btn btn-success waves-effect" style={{ float: "right" }}>
                                <a href="https://assets.bimeh.com/docs/tools/UserListSample.xlsx" style={{ color: "#fff" }}>
                                    <i className="fas fa-file-download  font-size-16 align-middle mr-2"></i> دانلود فایل نمونه</a>
                            </button>

                        </Col>
                        <Col span={24} >
                            <Form.Item style={{ marginRight: "10px" }}>
                                <button type="primary" className="btn btn-primary waves-effect waves-light float-left">
                                    <i className={loading ? "bx bx-loader bx-spin" : "bx bx-check-double "}></i>
                                    &nbsp;ثبت
                                </button>
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </div>

        </Modal >
    )
}
